"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVRStandardReportsService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("./base.service");
var api_constants_1 = require("../constants/api.constants");
var AVRStandardReportsService = /** @class */ (function (_super) {
    __extends(AVRStandardReportsService, _super);
    function AVRStandardReportsService(options, assessmentsStandardReportOfItemClient) {
        var _this = _super.call(this, options) || this;
        _this.assessmentsStandardReportOfItemClient = assessmentsStandardReportOfItemClient;
        return _this;
    }
    AVRStandardReportsService.newInstance = function (options) {
        return new AVRStandardReportsService(options, insync_assess_sdk_1.StandardsReportClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized));
    };
    /**
     * the list of domain for the respective curriculum on the basis of grades, schoolIds and curriculums available
     * @param {string} curriculum - curriculum id - eg em, emtx
     * @param {string} grade - user selected grade
     * @param {string[]} schoolIds - id of different schools
     * @param {string} customEnrollmentPeriod - user selected school year
     * @returns {Promise<IDomainsPerCurriculum[]>}
     */
    AVRStandardReportsService.prototype.findDomainListForCurriculum = function (filters, customEnrollmentPeriod, useV2) {
        if (useV2 === void 0) { useV2 = true; }
        var headers = this.getDefaultHeaders({ customEnrollmentPeriod: customEnrollmentPeriod });
        return useV2
            ? this.assessmentsStandardReportOfItemClient.domainsPerCurriculumReportV2(filters, headers)
            : this.assessmentsStandardReportOfItemClient.domainsPerCurriculumReport(filters, headers);
    };
    /**
     * show average score of all assessments and count of schools, students and standards
     * @param {string} curriculum - curriculum id - eg em, emtx
     * @param {string} grade - user selected grade
     * @param {string[]} schoolIds - id of different schools
     * @param {string} standardItemGlobalLevel0 eg: "CC-CCSS$A651907A$CCSS.Math.Content.1.OA"
     * @param {string} classIds - id of different classes
     * @param {string} standardItemGlobal eg: "CC-CCSS"
     * @param {string} enrollmentPeriodId - user selected school year
     * @returns {Promise<IAverageScorePerDomainStanardsReport>}
     */
    AVRStandardReportsService.prototype.getAverageScorePerDomainStandardsReport = function (filters, enrollmentPeriodId, useV2) {
        if (useV2 === void 0) { useV2 = true; }
        var headers = this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId });
        return useV2
            ? this.assessmentsStandardReportOfItemClient.averageScorePerDomainStandardsReportV2(filters, headers)
            : this.assessmentsStandardReportOfItemClient.averageScorePerDomainStandardsReport(filters, headers);
    };
    /**
     * performance distributions for the schools on the basis on curriculum, grade, schoolIds and standardItemGlobalLevel0
     * @param {string} curriculum - curriculum id - eg em, emtx
     * @param {string} grade - user selected grade
     * @param {string[]} schoolIds - id of different school
     * @param {string} standardItemGlobalLevel0 eg "CC-CCSS$A651907A$CCSS.Math.Content.1.OA"
     * @param {string} enrollmentPeriodId - user selected school year
     * @returns {Promise<IPerformanceDistributionBySchools[]>}
     */
    AVRStandardReportsService.prototype.getPerformanceDistributionBySchools = function (filters, enrollmentPeriodId, useV2) {
        if (useV2 === void 0) { useV2 = true; }
        var headers = this.getDefaultHeaders({ customEnrollmentPeriod: enrollmentPeriodId });
        return useV2
            ? this.assessmentsStandardReportOfItemClient.performanceDistributionBySchoolsV2(filters, headers)
            : this.assessmentsStandardReportOfItemClient.performanceDistributionBySchools(filters, headers);
    };
    return AVRStandardReportsService;
}(base_service_1.BaseService));
exports.AVRStandardReportsService = AVRStandardReportsService;
